import template from "./navbar.html";
import controller from "./navbar.controller";

const navBarComponent = {
  restrict: "E",
  template,
  bindings: {},
  controller,
};

export default navBarComponent;
